import { createFileRoute, useRouter } from "@tanstack/react-router";

import { AppointmentTypeTextFieldForm } from "@/components/appointment/type/appointment-type-text-field-form";

import type { JSX } from "react";

const CreateAppointmentTypePatientInformationPage = (): JSX.Element => {
  const router = useRouter();

  return (
    <AppointmentTypeTextFieldForm
      appointmentTypeId={null}
      field="patientInformation"
      onSaved={() => router.history.back()}
    />
  );
};

export const Route = createFileRoute(
  "/settings/schedule-options/appointment-types/create/patient-info",
)({
  component: CreateAppointmentTypePatientInformationPage,
});
